import Component from './index.vue';

Component.install = app => {
  app.component(Component.name, Component);
};

export default Component;
